import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconLoginSecurityConfig: FC<BaseIconProps> = ({ size, className, ...props }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    {...props}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.3334 8.33333V3H1.66669V13.6667H8.33335"
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M9.33331 9.33325L14.3333 10.8717L12.0256 12.0256L10.8718 14.3333L9.33331 9.33325Z"
                        stroke="currentColor"
                        strokeWidth="1.07143"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M3.99969 4.875C4.25272 4.875 4.4585 5.08003 4.45868 5.33301C4.45868 5.58614 4.25283 5.79199 3.99969 5.79199C3.74671 5.79182 3.54169 5.58603 3.54169 5.33301C3.54186 5.08014 3.74682 4.87518 3.99969 4.875ZM6.33368 4.875C6.58655 4.87518 6.79151 5.08014 6.79169 5.33301C6.79169 5.58603 6.58666 5.79182 6.33368 5.79199C6.08055 5.79199 5.87469 5.58614 5.87469 5.33301C5.87487 5.08003 6.08066 4.875 6.33368 4.875ZM8.66669 4.875C8.91971 4.875 9.12452 5.08003 9.12469 5.33301C9.12469 5.58614 8.91982 5.79199 8.66669 5.79199C8.41356 5.79199 8.20868 5.58614 8.20868 5.33301C8.20886 5.08003 8.41366 4.875 8.66669 4.875Z"
                        fill="currentColor"
                        stroke="currentColor"
                        strokeWidth="0.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    {...props}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(2,2)">
                        <path
                            d="M14.3334 8.33333V3H1.66669V13.6667H8.33335"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9.33331 9.33325L14.3333 10.8717L12.0256 12.0256L10.8718 14.3333L9.33331 9.33325Z"
                            stroke="currentColor"
                            strokeWidth="1.07143"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M3.99969 4.875C4.25272 4.875 4.4585 5.08003 4.45868 5.33301C4.45868 5.58614 4.25283 5.79199 3.99969 5.79199C3.74671 5.79182 3.54169 5.58603 3.54169 5.33301C3.54186 5.08014 3.74682 4.87518 3.99969 4.875ZM6.33368 4.875C6.58655 4.87518 6.79151 5.08014 6.79169 5.33301C6.79169 5.58603 6.58666 5.79182 6.33368 5.79199C6.08055 5.79199 5.87469 5.58614 5.87469 5.33301C5.87487 5.08003 6.08066 4.875 6.33368 4.875ZM8.66669 4.875C8.91971 4.875 9.12452 5.08003 9.12469 5.33301C9.12469 5.58614 8.91982 5.79199 8.66669 5.79199C8.41356 5.79199 8.20868 5.58614 8.20868 5.33301C8.20886 5.08003 8.41366 4.875 8.66669 4.875Z"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="0.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    {...props}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g transform="translate(4,4)">
                        <path
                            d="M14.3334 8.33333V3H1.66669V13.6667H8.33335"
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M9.33331 9.33325L14.3333 10.8717L12.0256 12.0256L10.8718 14.3333L9.33331 9.33325Z"
                            stroke="currentColor"
                            strokeWidth="1.07143"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M3.99969 4.875C4.25272 4.875 4.4585 5.08003 4.45868 5.33301C4.45868 5.58614 4.25283 5.79199 3.99969 5.79199C3.74671 5.79182 3.54169 5.58603 3.54169 5.33301C3.54186 5.08014 3.74682 4.87518 3.99969 4.875ZM6.33368 4.875C6.58655 4.87518 6.79151 5.08014 6.79169 5.33301C6.79169 5.58603 6.58666 5.79182 6.33368 5.79199C6.08055 5.79199 5.87469 5.58614 5.87469 5.33301C5.87487 5.08003 6.08066 4.875 6.33368 4.875ZM8.66669 4.875C8.91971 4.875 9.12452 5.08003 9.12469 5.33301C9.12469 5.58614 8.91982 5.79199 8.66669 5.79199C8.41356 5.79199 8.20868 5.58614 8.20868 5.33301C8.20886 5.08003 8.41366 4.875 8.66669 4.875Z"
                            fill="currentColor"
                            stroke="currentColor"
                            strokeWidth="0.25"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                </svg>
            );
    }
};
